module.exports = __webpack_public_path__ + "static/media/footerinstagram.4f056ba0.webp";